<template>
  <div class="CropSource">
    <!-- header -->
    <Header class="CropSourceHeader">
      <i
        class="iconfont icon-a-closethick"
        @click="centerDialogVisible"
      ></i>
      <p
        class="cropSourceName ellipsis"
        @click="editCropName"
        :title="programNameInput"
        v-if="!showInput"
      >
        <i
          class="iconfont icon-bianji"
        ></i>
        {{ programNameInput }}
      </p>
      <!-- Edit custom source name -->
      <el-input
        v-model="programNameInput"
        placeholder="The crop name"
        v-else
        class="CustomNameInput"
        ref="CustomNameInput"
        @change="showInput = false"
        @blur="showInput = false"
      ></el-input>
      <el-button
        class="doneBtn"
        type="primary"
        @click="saveCrop"
        :loading="loading"
      >{{ $t('lang.Done') }}
      </el-button>
    </Header>
    <div class="CropSourceWrap"></div>
    <!-- 侧边栏 -->
    <LBandSlider ref="LBandParamSet" :lBandInfo="NewlBandInfo" :VideoResolution="VideoResolution"/>
    <!-- 裁剪画布 -->
    <LBandCanvas
      :lBandInfo="NewlBandInfo"
      :currentName="programNameInput"
      :VideoResolution="VideoResolution"
    />
  </div>
</template>
<script>
import LBandSlider from './LBandSlider.vue'
import LBandCanvas from './LBandCanvas.vue'
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { mapState } from 'vuex'

export default {
  name: 'LBandCrop',
  props: {
    // 编辑的lBand信息
    lBandInfo: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LBandSlider,
    LBandCanvas
  },
  data () {
    return {
      showInput: false, // 显示编辑的输入框
      programNameInput: 'LBand',
      loading: false,
      // new lband信息
      NewlBandInfo: {},
      // 所选分辨率
      VideoResolution: {
        width: 1920,
        height: 1080
      }
    }
  },
  created () {
    if (this.AdvancedSetupConfig.VideoResolution && this.AdvancedSetupConfig.VideoResolution.width) {
      this.VideoResolution = {
        width: this.AdvancedSetupConfig.VideoResolution.width,
        height: this.AdvancedSetupConfig.VideoResolution.height
      }
    }
    this.dataTransformation()
  },
  computed: {
    ...mapState({
      // 高级配置的某些参数
      AdvancedSetupConfig: (state) => state.playout.AdvancedSetupConfig
    })
  },
  methods: {
    // 数据转换
    dataTransformation () {
      // 将已有的name赋值，并显示
      if (this.lBandInfo && this.lBandInfo.id) {
        this.programNameInput = this.lBandInfo.name
        this.NewlBandInfo = JSON.parse(JSON.stringify(this.lBandInfo))
      } else {
        this.NewlBandInfo = {
          x: 1152,
          y: 0,
          width: 768,
          height: 432,
          squeezeTime: 500,
          effectDuration: 10,
          squeezeType: 0,
          fileId: '',
          url: ''
        }
      }
      this.computeCoordinates(this.NewlBandInfo)
    },
    // 计算坐标
    computeCoordinates (item) {
      const width = item.width
      const height = item.height
      const outputWidth = this.VideoResolution.width
      const outputHeight = this.VideoResolution.height
      if (item.squeezeType === 3) {
        item.x = 0
        item.y = outputHeight - height
      } else if (item.squeezeType === 2) {
        item.x = 0
        item.y = 0
      } else if (item.squeezeType === 0) {
        item.x = outputWidth - width
        item.y = 0
      } else if (item.squeezeType === 1) {
        item.x = outputWidth - width
        item.y = outputHeight - height
      }
    },
    // 编辑名字
    editCropName () {
      this.showInput = true
      this.programNameInput = this.programNameInput
      this.$nextTick(() => {
        this.$refs.CustomNameInput.focus()
      })
    },
    // 保存
    saveCrop () {
      // 参数处理
      const param = this.ParamHandling()
      if (param.effectDuration < 1 || !/(\d+)/g.test(param.effectDuration)) {
        this.$message.error(this.$i18n.t('lang.pleaseInput1'))
        return
      }
      if (param.squeezeTime < 30 || !/(\d+)/g.test(param.squeezeTime)) {
        this.$message.error(this.$i18n.t('lang.pleaseInput30'))
        return
      }
      if (!param.url) {
        this.$message.error(this.$i18n.t('lang.uploadBg'))
        Bus.$emit('goBgTab')
        return
      }
      let url = '/L-Band/addLBand'
      if (this.lBandInfo.id) {
        url = '/L-Band/updateLBand'
      }
      this.loading = true
      this.axios
        .post(Outil.getUrl(url), param)
        .then(res => {
          this.loading = false
          if (res.data.errorCode == '0x0') {
            this.closeDialog({ page: 'save', close: false })
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 参数处理
    ParamHandling () {
      const OtherParame = this.$refs.LBandParamSet.OtherParame
      const position = this.$refs.LBandParamSet.position
      const programId = this.$BehaviorSyns.getProgramId()
      const param = {
        ...this.lBandInfo,
        ...position,
        ...OtherParame,
        programId,
        name: this.programNameInput
      }
      param.x = this.VideoResolution.width - param.width
      param.y = this.VideoResolution.height - param.height
      delete param.type
      return param
    },
    // 关闭编辑页面确认
    centerDialogVisible () {
      this.$confirm(this.$t('lang.backHint'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        this.closeDialog({ page: 'back', close: false })
      }).catch(() => {})
    },
    // 关闭编辑页面
    closeDialog (data) {
      this.$emit('close-Dialog', data)
    }
  }
}
</script>
<style lang="less" scoped>
.CropSource {
  height: 100%;
  width: 100%;
  background: #111213;
  position: relative;
  overflow: hidden;

  .CropSourceHeader {
    height: 64px;
    background: #181a1c;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .6);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon-a-closethick {
      font-size: 20px;
      color: #fff;
      margin-left: 37px;
    }

    .cropSourceName {
      width: 400px;
      color: #fff;
      font-size: 20px;
      text-align: center;
      margin-bottom: 0px;

      .icon-bianji{
        font-size: 20px;
        cursor: pointer;
      }
    }

    ::v-deep .CustomNameInput {
      width: 400px;
      background: rgba(49, 52, 54, 1);

      .el-input__inner {
        background: rgba(49, 52, 54, 1);
        border: 0;
        color: #fff;
        text-align: center;
        border-radius: 4px;
        height: 40px;
        border-color: transparent;
      }
    }

    .doneBtn {
      background: rgba(93, 192, 69, 1);
      border-radius: 4px;
      margin-right: 20px;
    }
  }
}
</style>
